angular.module('gym.pos').controller('ResendSaleModalCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "flash", "sale", function($scope, $rootScope, $modalInstance, $http, flash, sale) {
  $scope.sale = sale;
  $scope.send = function(form) {
    var params, url;
    if (form.$invalid || $scope.isLoading) {
      return;
    }
    $scope.isLoading = true;
    params = {
      customer_email: $scope.sale.customer_email
    };
    url = `/gyms/${$rootScope.gym.id}/pos/sales/${sale.id}/send_receipt`;
    return $http.put(url, params).then(function() {
      $scope.isLoading = false;
      $modalInstance.close();
      return flash.success = `Sale receipt delivered to ${params.customer_email}`;
    }, function() {
      $scope.isLoading = false;
      return flash.error = "There was an error processing the request.";
    });
  };
  return $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
